// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import {
//   Container, Row, Col, Form, Button, Modal,
//   Alert, Spinner, Table, Card, Dropdown, ListGroup, Badge
// } from 'react-bootstrap';
// import { CSVLink } from 'react-csv';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';
// import api from '../api';
// import './StockManagement.css'; // Create this CSS file

// // Custom hook for mobile detection
// const useIsMobile = () => {
//   const [isMobile, setIsMobile] = useState(false);
  
//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);
  
//   return isMobile;
// };

// // Subcomponent for sortable table headers
// const SortableHeader = ({ label, sortKey, onSort, currentSort, isMobile }) => (
//   <th
//     onClick={() => onSort(sortKey)}
//     style={{ cursor: 'pointer' }}
//     className={`user-select-none ${isMobile ? 'px-2 py-1' : 'bg-light'}`}
//   >
//     {label}
//     {currentSort.key === sortKey && (currentSort.direction === 'asc' ? ' ↑' : ' ↓')}
//   </th>
// );

// export default function StockManagement() {
//   const { user, logout } = useAuth();
//   const isMobile = useIsMobile();
//   const [items, setItems] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [sortConfig, setSortConfig] = useState({ key: 'type', direction: 'asc' });
//   const [showMobileActions, setShowMobileActions] = useState(null);

//   const [formData, setFormData] = useState({
//     type: '',
//     cost: '',
//     sellingPrice: '',
//     quantity: ''
//   });

//   const itemsPerPage = isMobile ? 15 : 30;
//   const csvHeaders = [
//     { label: 'Item Name', key: 'type' },
//     { label: 'Cost/Unit (Ksh)', key: 'cost' },
//     { label: 'Selling Price (Ksh)', key: 'sellingPrice' },
//     { label: 'Profit Margin (%)', key: 'profitMargin' },
//     { label: 'Stock Quantity', key: 'quantity' }
//   ];

//   useEffect(() => {
//     const responseInterceptor = api.interceptors.response.use(
//       res => res,
//       err => {
//         if (err.response?.status === 401) {
//           logout();
//           setError('Session expired. Please login again.');
//         }
//         return Promise.reject(err);
//       }
//     );

//     return () => api.interceptors.response.eject(responseInterceptor);
//   }, [logout]);

//   const { totalCostValue, totalSellingValue } = useMemo(() =>
//     items.reduce((acc, item) => ({
//       totalCostValue: acc.totalCostValue + (item.cost * item.quantity),
//       totalSellingValue: acc.totalSellingValue + (item.sellingPrice * item.quantity)
//     }), { totalCostValue: 0, totalSellingValue: 0 }),
//     [items]
//   );

//   const fetchItems = useCallback(async (cancelTokenSource) => {
//     try {
//       setLoading(true);
//       const { data } = await api.get('/stock', {
//         params: {
//           page: currentPage,
//           limit: itemsPerPage,
//           sortBy: sortConfig.key,
//           sortOrder: sortConfig.direction,
//           search: searchTerm.toLowerCase()
//         },
//         cancelToken: cancelTokenSource?.token
//       });

//       setItems(data.items || []);
//       setTotalPages(data.totalPages || 1);
//       setError('');
//     } catch (err) {
//       if (!axios.isCancel(err)) {
//         setError(err.response?.data?.message || 'Failed to load items');
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, sortConfig, searchTerm, itemsPerPage]);

//   useEffect(() => {
//     const cancelTokenSource = axios.CancelToken.source();
//     const debounceTimer = setTimeout(() => fetchItems(cancelTokenSource), 300);

//     return () => {
//       cancelTokenSource.cancel();
//       clearTimeout(debounceTimer);
//     };
//   }, [fetchItems]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const cost = parseFloat(formData.cost);
//       const sellingPrice = parseFloat(formData.sellingPrice);

//       if (sellingPrice <= cost) {
//         throw new Error('Selling price must be greater than cost price');
//       }

//       const payload = {
//         type: formData.type.trim().toLowerCase(),
//         cost,
//         sellingPrice,
//         quantity: parseInt(formData.quantity)
//       };

//       const endpoint = selectedItem ? `/stock/${selectedItem._id}` : '/stock';
//       const method = selectedItem ? 'put' : 'post';

//       await api[method](endpoint, payload);
//       await fetchItems();
//       handleCloseModal();
//     } catch (err) {
//       setError(err.response?.data?.message || err.message || 'Operation failed');
//     }
//   };

//   const handleSort = (key) => {
//     setSortConfig(prev => ({
//       key,
//       direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
//     }));
//   };

//   const handleEdit = (item) => {
//     setSelectedItem(item);
//     setFormData({
//       type: item.type,
//       cost: item.cost.toString(),
//       sellingPrice: item.sellingPrice.toString(),
//       quantity: item.quantity.toString()
//     });
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm('Are you sure you want to delete this item?')) {
//       try {
//         await api.delete(`/stock/${id}`);
//         await fetchItems();
//       } catch (err) {
//         setError(err.response?.data?.message || 'Failed to delete item');
//       }
//     }
//   };

//   const handleCloseModal = () => {
//     setSelectedItem(null);
//     setFormData({ type: '', cost: '', sellingPrice: '', quantity: '' });
//     setShowModal(false);
//     setError('');
//   };

//   const calculateProfitMargin = () => {
//     const cost = parseFloat(formData.cost) || 0;
//     const price = parseFloat(formData.sellingPrice) || 0;
//     return cost > 0 ? ((price - cost) / cost * 100).toFixed(2) : '0.00';
//   };

//   const StockValueCards = () => (
//     <Row className="mb-4 g-2">
//       <Col xs={12} md={6}>
//         <Card className="h-100 shadow-sm">
//           <Card.Body className="p-2 p-sm-3">
//             <Card.Title className="fs-6">Inventory Value</Card.Title>
//             <Card.Text className={`text-primary ${isMobile ? 'fs-5' : 'fs-4'}`}>
//               Ksh{totalCostValue.toLocaleString(undefined, { maximumFractionDigits: 2 })}
//             </Card.Text>
//             <Card.Subtitle className="text-muted small">Cost Basis</Card.Subtitle>
//           </Card.Body>
//         </Card>
//       </Col>
//       <Col xs={12} md={6}>
//         <Card className="h-100 shadow-sm">
//           <Card.Body className="p-2 p-sm-3">
//             <Card.Title className="fs-6">Potential Revenue</Card.Title>
//             <Card.Text className={`text-success ${isMobile ? 'fs-5' : 'fs-4'}`}>
//               Ksh{totalSellingValue.toLocaleString(undefined, { maximumFractionDigits: 2 })}
//             </Card.Text>
//             <Card.Subtitle className="text-muted small">Selling Price Basis</Card.Subtitle>
//           </Card.Body>
//         </Card>
//       </Col>
//     </Row>
//   );

//   const PaginationControls = () => (
//     <div className="d-flex justify-content-center mt-3 gap-1">
//       <Button
//         variant="outline-primary"
//         size={isMobile ? "sm" : undefined}
//         onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
//         disabled={currentPage === 1}
//       >
//         Prev
//       </Button>
//       <span className="align-self-center small">{currentPage}/{totalPages}</span>
//       <Button
//         variant="outline-primary"
//         size={isMobile ? "sm" : undefined}
//         onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
//         disabled={currentPage === totalPages}
//       >
//         Next
//       </Button>
//     </div>
//   );

//   const EmptyState = () => (
//     <div className="text-center my-4 p-3 bg-light rounded">
//       <h5 className="text-muted mb-2 fs-6">No stock items found</h5>
//       <p className="text-muted mb-3 small">Add your first inventory item</p>
//       <Button variant="primary" size={isMobile ? "sm" : undefined} onClick={() => setShowModal(true)}>
//         Add New Item
//       </Button>
//     </div>
//   );

//   const MobileItemList = () => (
//     <ListGroup className="mb-3">
//       {items.map(item => (
//         <ListGroup.Item key={item._id} className="position-relative">
//           <div className="d-flex justify-content-between align-items-start">
//             <div className="w-75">
//               <div className="fw-bold text-truncate">{item.type}</div>
//               <div className="d-flex justify-content-between small mt-1">
//                 <div>Cost: <span className="text-primary">Ksh{item.cost.toFixed(2)}</span></div>
//                 <div>Price: <span className="text-success">Ksh{item.sellingPrice.toFixed(2)}</span></div>
//               </div>
//               <div className="d-flex justify-content-between small mt-1">
//                 <div>Qty: <Badge bg={item.quantity < 10 ? "warning" : "success"}>{item.quantity}</Badge></div>
//                 <div>Margin: <Badge bg="info">{
//                   ((item.sellingPrice - item.cost) / item.cost * 100).toFixed(2)}%
//                 </Badge></div>
//               </div>
//             </div>
            
//             <Dropdown show={showMobileActions === item._id} onToggle={(isOpen) => 
//               setShowMobileActions(isOpen ? item._id : null)
//             }>
//               <Dropdown.Toggle variant="link" className="p-0 text-dark">
//                 <i className="bi bi-three-dots-vertical fs-5"></i>
//               </Dropdown.Toggle>
              
//               <Dropdown.Menu align="end">
//                 <Dropdown.Item onClick={() => handleEdit(item)}>
//                   <i className="bi bi-pencil me-2"></i> Edit
//                 </Dropdown.Item>
//                 <Dropdown.Item onClick={() => handleDelete(item._id)} className="text-danger">
//                   <i className="bi bi-trash me-2"></i> Delete
//                 </Dropdown.Item>
//               </Dropdown.Menu>
//             </Dropdown>
//           </div>
//         </ListGroup.Item>
//       ))}
//     </ListGroup>
//   );

//   return (
//     <Container fluid className={`px-${isMobile ? '2' : '4'} py-3`}>
//       <Row className="mb-3 g-2">
//         <Col xs={12} md={6}>
//           <Form.Control
//             type="search"
//             placeholder="Search items..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             size={isMobile ? "sm" : undefined}
//           />
//         </Col>
//         <Col xs={12} md="auto" className="d-flex gap-2">
//           <CSVLink
//             data={items.map(item => ({
//               ...item,
//               profitMargin: ((item.sellingPrice - item.cost) / item.cost * 100).toFixed(2)
//             }))}
//             headers={csvHeaders}
//             filename="stock-inventory.csv"
//             className={`btn ${isMobile ? 'btn-sm' : ''} btn-success`}
//           >
//             {isMobile ? 'CSV' : 'Export CSV'}
//           </CSVLink>
//           <Button 
//             onClick={() => setShowModal(true)} 
//             size={isMobile ? "sm" : undefined}
//             className="w-100"
//           >
//             Add Item
//           </Button>
//         </Col>
//       </Row>

//       <StockValueCards />

//       {error && (
//         <Alert variant="danger" dismissible onClose={() => setError('')} className="py-2">
//           <small>{error}</small>
//         </Alert>
//       )}

//       {loading ? (
//         <div className="text-center my-4 py-5">
//           <Spinner animation="border" size={isMobile ? "sm" : undefined} />
//           <p className="mt-2 small">Loading inventory...</p>
//         </div>
//       ) : items.length === 0 ? (
//         <EmptyState />
//       ) : isMobile ? (
//         <>
//           <MobileItemList />
//           {totalPages > 1 && <PaginationControls />}
//         </>
//       ) : (
//         <>
//           <div className="table-responsive">
//             <Table striped bordered hover className="shadow-sm mb-0">
//               <thead>
//                 <tr>
//                   <SortableHeader 
//                     label="Item Name" 
//                     sortKey="type" 
//                     onSort={handleSort} 
//                     currentSort={sortConfig} 
//                     isMobile={isMobile}
//                   />
//                   <SortableHeader 
//                     label="Cost/Unit" 
//                     sortKey="cost" 
//                     onSort={handleSort} 
//                     currentSort={sortConfig} 
//                     isMobile={isMobile}
//                   />
//                   <SortableHeader 
//                     label="Selling Price" 
//                     sortKey="sellingPrice" 
//                     onSort={handleSort} 
//                     currentSort={sortConfig} 
//                     isMobile={isMobile}
//                   />
//                   <SortableHeader 
//                     label="Profit Margin" 
//                     sortKey="profitMargin" 
//                     onSort={handleSort} 
//                     currentSort={sortConfig} 
//                     isMobile={isMobile}
//                   />
//                   <SortableHeader 
//                     label="Quantity" 
//                     sortKey="quantity" 
//                     onSort={handleSort} 
//                     currentSort={sortConfig} 
//                     isMobile={isMobile}
//                   />
//                   <th className="bg-light">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {items.map(item => (
//                   <tr key={item._id}>
//                     <td>{item.type}</td>
//                     <td>Ksh{item.cost.toFixed(2)}</td>
//                     <td>Ksh{item.sellingPrice.toFixed(2)}</td>
//                     <td>{((item.sellingPrice - item.cost) / item.cost * 100).toFixed(2)}%</td>
//                     <td>{item.quantity}</td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <Button size="sm" variant="outline-info" onClick={() => handleEdit(item)}>Edit</Button>
//                         <Button size="sm" variant="outline-danger" onClick={() => handleDelete(item._id)}>Delete</Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//           {totalPages > 1 && <PaginationControls />}
//         </>
//       )}

//       {/* Modal */}
//       <Modal 
//         show={showModal} 
//         onHide={handleCloseModal} 
//         centered
//         fullscreen={isMobile ? "sm-down" : undefined}
//       >
//         <Modal.Header closeButton className={isMobile ? "py-2" : ""}>
//           <Modal.Title className={isMobile ? "fs-6" : ""}>
//             {selectedItem ? 'Edit Item' : 'New Inventory Item'}
//           </Modal.Title>
//         </Modal.Header>
//         <Form onSubmit={handleSubmit}>
//           <Modal.Body className={isMobile ? "p-3" : ""}>
//             <Form.Group className="mb-3">
//               <Form.Label>Item Name *</Form.Label>
//               <Form.Control
//                 required
//                 value={formData.type}
//                 onChange={(e) => setFormData({ ...formData, type: e.target.value })}
//                 size={isMobile ? "sm" : undefined}
//               />
//             </Form.Group>

//             <Row>
//               <Col xs={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Cost/Unit (Ksh) *</Form.Label>
//                   <Form.Control
//                     type="number"
//                     step="0.01"
//                     min="0.01"
//                     required
//                     value={formData.cost}
//                     onChange={(e) => setFormData({ ...formData, cost: e.target.value })}
//                     size={isMobile ? "sm" : undefined}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col xs={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Selling Price (Ksh) *</Form.Label>
//                   <Form.Control
//                     type="number"
//                     step="0.01"
//                     min="0.01"
//                     required
//                     value={formData.sellingPrice}
//                     onChange={(e) => setFormData({ ...formData, sellingPrice: e.target.value })}
//                     size={isMobile ? "sm" : undefined}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Form.Group className="mb-3">
//               <Form.Label>Profit Margin</Form.Label>
//               <Form.Control 
//                 plaintext 
//                 readOnly 
//                 value={`${calculateProfitMargin()}%`} 
//                 className="fw-bold text-success"
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Quantity *</Form.Label>
//               <Form.Control
//                 type="number"
//                 min="1"
//                 required
//                 value={formData.quantity}
//                 onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
//                 size={isMobile ? "sm" : undefined}
//               />
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer className={isMobile ? "py-2" : ""}>
//             <Button 
//               variant="secondary" 
//               onClick={handleCloseModal}
//               size={isMobile ? "sm" : undefined}
//             >
//               Cancel
//             </Button>
//             <Button 
//               type="submit" 
//               variant="primary" 
//               disabled={loading}
//               size={isMobile ? "sm" : undefined}
//             >
//               {selectedItem ? 'Update' : 'Add Item'}
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>
//     </Container>
//   );
// }

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Container, Row, Col, Form, Button, Modal,
  Alert, Spinner, Table, Card, Dropdown, ListGroup, Badge,
  Toast, ToastContainer
} from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import './StockManagement.css';
import { BsExclamationTriangleFill, BsExclamationCircleFill } from 'react-icons/bs';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  return isMobile;
};

const SortableHeader = ({ label, sortKey, onSort, currentSort, isMobile }) => (
  <th
    onClick={() => onSort(sortKey)}
    style={{ cursor: 'pointer' }}
    className={`user-select-none ${isMobile ? 'px-2 py-1' : 'bg-light'}`}
  >
    {label}
    {currentSort.key === sortKey && (currentSort.direction === 'asc' ? ' ↑' : ' ↓')}
  </th>
);

export default function StockManagement() {
  const { user, logout } = useAuth();
  const isMobile = useIsMobile();
  const [allItems, setAllItems] = useState([]);
  const [paginatedItems, setPaginatedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: 'type', direction: 'asc' });
  const [showMobileActions, setShowMobileActions] = useState(null);
  const [showStockAlerts, setShowStockAlerts] = useState(true);
  const [lowStockItems, setLowStockItems] = useState([]);
  const [outOfStockItems, setOutOfStockItems] = useState([]);

  const [formData, setFormData] = useState({
    type: '',
    cost: '',
    sellingPrice: '',
    quantity: ''
  });

  const itemsPerPage = isMobile ? 15 : 30;
  const csvHeaders = [
    { label: 'Item Name', key: 'type' },
    { label: 'Cost/Unit (Ksh)', key: 'cost' },
    { label: 'Selling Price (Ksh)', key: 'sellingPrice' },
    { label: 'Profit Margin (%)', key: 'profitMargin' },
    { label: 'Stock Quantity', key: 'quantity' },
    { label: 'Stock Status', key: 'status' }
  ];

  // Calculate global totals from all items
  const { globalTotalCostValue, globalTotalSellingValue } = useMemo(() => {
    return allItems.reduce((acc, item) => {
      const cost = typeof item.cost === 'number' ? item.cost : parseFloat(item.cost) || 0;
      const sellingPrice = typeof item.sellingPrice === 'number' ? item.sellingPrice : parseFloat(item.sellingPrice) || 0;
      const quantity = typeof item.quantity === 'number' ? item.quantity : parseInt(item.quantity) || 0;
      
      return {
        globalTotalCostValue: acc.globalTotalCostValue + (cost * quantity),
        globalTotalSellingValue: acc.globalTotalSellingValue + (sellingPrice * quantity)
      };
    }, { globalTotalCostValue: 0, globalTotalSellingValue: 0 });
  }, [allItems]);

  // Identify low stock and out-of-stock items
  useEffect(() => {
    const lowStock = allItems.filter(item => item.quantity > 0 && item.quantity < 10);
    const outOfStock = allItems.filter(item => item.quantity === 0);
    
    setLowStockItems(lowStock);
    setOutOfStockItems(outOfStock);
  }, [allItems]);

  useEffect(() => {
    const responseInterceptor = api.interceptors.response.use(
      res => res,
      err => {
        if (err.response?.status === 401) {
          logout();
          setError('Session expired. Please login again.');
        }
        return Promise.reject(err);
      }
    );

    return () => api.interceptors.response.eject(responseInterceptor);
  }, [logout]);

  const fetchAllItems = useCallback(async (cancelTokenSource) => {
    try {
      setLoading(true);
      
      // Fetch all items without pagination
      const { data } = await api.get('/stock', {
        params: {
          limit: 0,
          sortBy: sortConfig.key,
          sortOrder: sortConfig.direction,
          search: searchTerm.toLowerCase()
        },
        cancelToken: cancelTokenSource?.token
      });
      
      setAllItems(data.items || []);
      setError('');
      
      // Calculate pagination
      const total = data.items?.length || 0;
      const totalPages = itemsPerPage > 0 ? Math.ceil(total / itemsPerPage) : 1;
      setTotalPages(totalPages);
      
      // Get items for current page
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginated = data.items?.slice(startIndex, endIndex) || [];
      setPaginatedItems(paginated);
    } catch (err) {
      if (!axios.isCancel(err)) {
        setError(err.response?.data?.message || 'Failed to load items');
      }
    } finally {
      setLoading(false);
    }
  }, [currentPage, sortConfig, searchTerm, itemsPerPage]);

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();
    const debounceTimer = setTimeout(() => fetchAllItems(cancelTokenSource), 300);

    return () => {
      cancelTokenSource.cancel();
      clearTimeout(debounceTimer);
    };
  }, [fetchAllItems]);

  // Enhanced currency formatting
  const formatCurrency = (value) => {
    try {
      const num = typeof value === 'number' ? value : 
                  typeof value === 'string' ? parseFloat(value) : 
                  Number(value) || 0;
      
      return num.toLocaleString('en-KE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      return '0.00';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const cost = parseFloat(formData.cost);
      const sellingPrice = parseFloat(formData.sellingPrice);

      if (sellingPrice <= cost) {
        throw new Error('Selling price must be greater than cost price');
      }

      const payload = {
        type: formData.type.trim().toLowerCase(),
        cost,
        sellingPrice,
        quantity: parseInt(formData.quantity)
      };

      const endpoint = selectedItem ? `/stock/${selectedItem._id}` : '/stock';
      const method = selectedItem ? 'put' : 'post';

      await api[method](endpoint, payload);
      await fetchAllItems();
      handleCloseModal();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Operation failed');
    }
  };

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setFormData({
      type: item.type,
      cost: item.cost.toString(),
      sellingPrice: item.sellingPrice.toString(),
      quantity: item.quantity.toString()
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await api.delete(`/stock/${id}`);
        await fetchAllItems();
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to delete item');
      }
    }
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
    setFormData({ type: '', cost: '', sellingPrice: '', quantity: '' });
    setShowModal(false);
    setError('');
  };

  const calculateProfitMargin = () => {
    const cost = parseFloat(formData.cost) || 0;
    const price = parseFloat(formData.sellingPrice) || 0;
    return cost > 0 ? ((price - cost) / cost * 100).toFixed(2) : '0.00';
  };

  const getStockStatus = (quantity) => {
    if (quantity === 0) return 'Out of Stock';
    if (quantity < 10) return 'Low Stock';
    return 'In Stock';
  };

  const getStatusBadge = (quantity) => {
    if (quantity === 0) return <Badge bg="danger" className="ms-2">Out of Stock</Badge>;
    if (quantity < 10) return <Badge bg="warning" className="ms-2">Low Stock</Badge>;
    return <Badge bg="success" className="ms-2">In Stock</Badge>;
  };

  const StockValueCards = () => (
    <Row className="mb-4 g-2">
      <Col xs={12} md={6}>
        <Card className="h-100 shadow-sm">
          <Card.Body className="p-2 p-sm-3">
            <Card.Title className="fs-6">Total Inventory Value</Card.Title>
            <Card.Text className={`text-primary ${isMobile ? 'fs-5' : 'fs-4'}`}>
              Ksh {formatCurrency(globalTotalCostValue)}
            </Card.Text>
            <Card.Subtitle className="text-muted small">
              All items • Cost Basis
            </Card.Subtitle>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={12} md={6}>
        <Card className="h-100 shadow-sm">
          <Card.Body className="p-2 p-sm-3">
            <Card.Title className="fs-6">Total Potential Revenue</Card.Title>
            <Card.Text className={`text-success ${isMobile ? 'fs-5' : 'fs-4'}`}>
              Ksh {formatCurrency(globalTotalSellingValue)}
            </Card.Text>
            <Card.Subtitle className="text-muted small">
              All items • Selling Price Basis
            </Card.Subtitle>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );

  const PaginationControls = () => (
    <div className="d-flex justify-content-center mt-3 gap-1">
      <Button
        variant="outline-primary"
        size={isMobile ? "sm" : undefined}
        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
        disabled={currentPage === 1}
      >
        Prev
      </Button>
      <span className="align-self-center small">{currentPage}/{totalPages}</span>
      <Button
        variant="outline-primary"
        size={isMobile ? "sm" : undefined}
        onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
        disabled={currentPage === totalPages}
      >
        Next
      </Button>
    </div>
  );

  const EmptyState = () => (
    <div className="text-center my-4 p-3 bg-light rounded">
      <h5 className="text-muted mb-2 fs-6">No stock items found</h5>
      <p className="text-muted mb-3 small">Add your first inventory item</p>
      <Button variant="primary" size={isMobile ? "sm" : undefined} onClick={() => setShowModal(true)}>
        Add New Item
      </Button>
    </div>
  );

  const MobileItemList = () => (
    <ListGroup className="mb-3">
      {paginatedItems.map(item => (
        <ListGroup.Item 
          key={item._id} 
          className="position-relative"
          style={{ 
            backgroundColor: item.quantity === 0 ? '#fff8f8' : 
                            item.quantity < 10 ? '#fffdf0' : 'inherit' 
          }}
        >
          <div className="d-flex justify-content-between align-items-start">
            <div className="w-75">
              <div className="fw-bold text-truncate">
                {item.type} {getStatusBadge(item.quantity)}
              </div>
              <div className="d-flex justify-content-between small mt-1">
                <div>Cost: <span className="text-primary">Ksh{item.cost.toFixed(2)}</span></div>
                <div>Price: <span className="text-success">Ksh{item.sellingPrice.toFixed(2)}</span></div>
              </div>
              <div className="d-flex justify-content-between small mt-1">
                <div>Qty: 
                  {item.quantity === 0 ? (
                    <Badge bg="danger" className="ms-1">0</Badge>
                  ) : item.quantity < 10 ? (
                    <Badge bg="warning" className="ms-1">{item.quantity}</Badge>
                  ) : (
                    <Badge bg="success" className="ms-1">{item.quantity}</Badge>
                  )}
                </div>
                <div>Margin: <Badge bg="info">{
                  ((item.sellingPrice - item.cost) / item.cost * 100).toFixed(2)}%
                </Badge></div>
              </div>
            </div>
            
            <Dropdown show={showMobileActions === item._id} onToggle={(isOpen) => 
              setShowMobileActions(isOpen ? item._id : null)
            }>
              <Dropdown.Toggle variant="link" className="p-0 text-dark">
                <i className="bi bi-three-dots-vertical fs-5"></i>
              </Dropdown.Toggle>
              
              <Dropdown.Menu align="end">
                <Dropdown.Item onClick={() => handleEdit(item)}>
                  <i className="bi bi-pencil me-2"></i> Edit
                </Dropdown.Item>
                <Dropdown.Item onClick={() => handleDelete(item._id)} className="text-danger">
                  <i className="bi bi-trash me-2"></i> Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );

  const StockAlertsToast = () => (
    <ToastContainer position={isMobile ? "top-center" : "top-end"} className="p-3">
      <Toast 
        show={showStockAlerts && (lowStockItems.length > 0 || outOfStockItems.length > 0)} 
        onClose={() => setShowStockAlerts(false)}
        bg="light"
        delay={10000}
        autohide
      >
        <Toast.Header closeButton>
          <strong className="me-auto">
            <BsExclamationTriangleFill className="text-warning me-2" />
            Stock Alerts
          </strong>
        </Toast.Header>
        <Toast.Body>
          {outOfStockItems.length > 0 && (
            <div className="mb-2">
              <div className="d-flex align-items-center">
                <BsExclamationCircleFill className="text-danger me-2" />
                <strong>Out of Stock:</strong>
              </div>
              <div className="ms-3 mt-1 small">
                {outOfStockItems.slice(0, 3).map(item => (
                  <div key={item._id} className="d-flex justify-content-between">
                    <span>{item.type}</span>
                    <Badge bg="danger">0</Badge>
                  </div>
                ))}
                {outOfStockItems.length > 3 && (
                  <div className="text-muted mt-1">
                    +{outOfStockItems.length - 3} more items...
                  </div>
                )}
              </div>
            </div>
          )}
          
          {lowStockItems.length > 0 && (
            <div>
              <div className="d-flex align-items-center">
                <BsExclamationTriangleFill className="text-warning me-2" />
                <strong>Low Stock:</strong>
              </div>
              <div className="ms-3 mt-1 small">
                {lowStockItems.slice(0, 3).map(item => (
                  <div key={item._id} className="d-flex justify-content-between">
                    <span>{item.type}</span>
                    <Badge bg="warning">{item.quantity}</Badge>
                  </div>
                ))}
                {lowStockItems.length > 3 && (
                  <div className="text-muted mt-1">
                    +{lowStockItems.length - 3} more items...
                  </div>
                )}
              </div>
            </div>
          )}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );

  return (
    <Container fluid className={`px-${isMobile ? '2' : '4'} py-3`}>
      <StockAlertsToast />
      
      <Row className="mb-3 g-2">
        <Col xs={12} md={6}>
          <Form.Control
            type="search"
            placeholder="Search items..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            size={isMobile ? "sm" : undefined}
          />
        </Col>
        <Col xs={12} md="auto" className="d-flex gap-2">
          <CSVLink
            data={allItems.map(item => ({
              ...item,
              profitMargin: ((item.sellingPrice - item.cost) / item.cost * 100).toFixed(2),
              status: getStockStatus(item.quantity)
            }))}
            headers={csvHeaders}
            filename="stock-inventory.csv"
            className={`btn ${isMobile ? 'btn-sm' : ''} btn-success`}
          >
            {isMobile ? 'CSV' : 'Export CSV'}
          </CSVLink>
          <Button 
            onClick={() => setShowModal(true)} 
            size={isMobile ? "sm" : undefined}
            className="w-100"
          >
            Add Item
          </Button>
        </Col>
      </Row>

      <StockValueCards />

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')} className="py-2">
          <small>{error}</small>
        </Alert>
      )}

      {loading ? (
        <div className="text-center my-4 py-5">
          <Spinner animation="border" size={isMobile ? "sm" : undefined} />
          <p className="mt-2 small">Loading inventory...</p>
        </div>
      ) : allItems.length === 0 ? (
        <EmptyState />
      ) : isMobile ? (
        <>
          <MobileItemList />
          {totalPages > 1 && <PaginationControls />}
        </>
      ) : (
        <>
          <div className="table-responsive">
            <Table striped bordered hover className="shadow-sm mb-0">
              <thead>
                <tr>
                  <SortableHeader 
                    label="Item Name" 
                    sortKey="type" 
                    onSort={handleSort} 
                    currentSort={sortConfig} 
                    isMobile={isMobile}
                  />
                  <SortableHeader 
                    label="Cost/Unit" 
                    sortKey="cost" 
                    onSort={handleSort} 
                    currentSort={sortConfig} 
                    isMobile={isMobile}
                  />
                  <SortableHeader 
                    label="Selling Price" 
                    sortKey="sellingPrice" 
                    onSort={handleSort} 
                    currentSort={sortConfig} 
                    isMobile={isMobile}
                  />
                  <SortableHeader 
                    label="Profit Margin" 
                    sortKey="profitMargin" 
                    onSort={handleSort} 
                    currentSort={sortConfig} 
                    isMobile={isMobile}
                  />
                  <SortableHeader 
                    label="Quantity" 
                    sortKey="quantity" 
                    onSort={handleSort} 
                    currentSort={sortConfig} 
                    isMobile={isMobile}
                  />
                  <th className="bg-light">Status</th>
                  <th className="bg-light">Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedItems.map(item => {
                  const isOutOfStock = item.quantity === 0;
                  const isLowStock = item.quantity > 0 && item.quantity < 10;
                  
                  return (
                    <tr 
                      key={item._id}
                      className={isOutOfStock ? 'table-danger' : isLowStock ? 'table-warning' : ''}
                    >
                      <td>{item.type}</td>
                      <td>Ksh{item.cost.toFixed(2)}</td>
                      <td>Ksh{item.sellingPrice.toFixed(2)}</td>
                      <td>{((item.sellingPrice - item.cost) / item.cost * 100).toFixed(2)}%</td>
                      <td>
                        {isOutOfStock ? (
                          <Badge bg="danger">Out of Stock</Badge>
                        ) : isLowStock ? (
                          <Badge bg="warning">Low: {item.quantity}</Badge>
                        ) : (
                          item.quantity
                        )}
                      </td>
                      <td>
                        {getStatusBadge(item.quantity)}
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button size="sm" variant="outline-info" onClick={() => handleEdit(item)}>Edit</Button>
                          <Button size="sm" variant="outline-danger" onClick={() => handleDelete(item._id)}>Delete</Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          {totalPages > 1 && <PaginationControls />}
        </>
      )}

      <Modal 
        show={showModal} 
        onHide={handleCloseModal} 
        centered
        fullscreen={isMobile ? "sm-down" : undefined}
      >
        <Modal.Header closeButton className={isMobile ? "py-2" : ""}>
          <Modal.Title className={isMobile ? "fs-6" : ""}>
            {selectedItem ? 'Edit Item' : 'New Inventory Item'}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body className={isMobile ? "p-3" : ""}>
            <Form.Group className="mb-3">
              <Form.Label>Item Name *</Form.Label>
              <Form.Control
                required
                value={formData.type}
                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                size={isMobile ? "sm" : undefined}
              />
            </Form.Group>

            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Cost/Unit (Ksh) *</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    min="0.01"
                    required
                    value={formData.cost}
                    onChange={(e) => setFormData({ ...formData, cost: e.target.value })}
                    size={isMobile ? "sm" : undefined}
                  />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Selling Price (Ksh) *</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    min="0.01"
                    required
                    value={formData.sellingPrice}
                    onChange={(e) => setFormData({ ...formData, sellingPrice: e.target.value })}
                    size={isMobile ? "sm" : undefined}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Profit Margin</Form.Label>
              <Form.Control 
                plaintext 
                readOnly 
                value={`${calculateProfitMargin()}%`} 
                className="fw-bold text-success"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Quantity *</Form.Label>
              <Form.Control
                type="number"
                min="0"
                required
                value={formData.quantity}
                onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
                size={isMobile ? "sm" : undefined}
              />
              {parseInt(formData.quantity) === 0 && (
                <Form.Text className="text-danger">
                  This item will be marked as "Out of Stock"
                </Form.Text>
              )}
              {parseInt(formData.quantity) > 0 && parseInt(formData.quantity) < 10 && (
                <Form.Text className="text-warning">
                  This item will be marked as "Low Stock"
                </Form.Text>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className={isMobile ? "py-2" : ""}>
            <Button 
              variant="secondary" 
              onClick={handleCloseModal}
              size={isMobile ? "sm" : undefined}
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              variant="primary" 
              disabled={loading}
              size={isMobile ? "sm" : undefined}
            >
              {selectedItem ? 'Update' : 'Add Item'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}